import { Suspense } from 'react';
import { Outlet, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { ThemeProvider } from "@mui/material/styles";

import { Menu } from "./Menu/menu";
import { Footer } from "./Footer/footer";
import { useEffect, useState } from "react";
import { NavigationTabs } from "./Menu/NavigationTabs/navigationTabs";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";

import { ErrorBoundary } from "../../Common/ErrorBoundary/errorBoundary.jsx";
import { getUser } from "../../../Requests/CommonRequests/commonRequests.jsx";
import { redirectToLoginWithReturn } from "../../../Utils/Helpers/Fetch/advancedFetch";
import { SimpleLoader } from "../../Common/Loader/simpleLoader.jsx";
import { themeContent } from "../../../Themes/themes.jsx";
import * as ActionUser from "../../../redux/actions/actionUser";
import * as ActionInternalSystem from "../../../redux/actions/actionInternalSystem";
import * as ActionReview from "../../../redux/actions/actionReview";
import * as ActionProperty from "../../../redux/actions/actionProperty";
import * as ActionBooking from "../../../redux/actions/actionBooking";
import * as ActionPropertyType from "../../../redux/actions/actionPropertyType";
import * as ActionRegion from "../../../redux/actions/actionRegion";
import * as ActionCurrency from "../../../redux/actions/actionCurrency";

export function Layout(props) {
    const [isLoaded, setIsLoaded] = useState(false);
    const user = useSelector(state => state.user);
    const internalSystem = useSelector(state => state.internalSystem);
    const review = useSelector(state => state.review);
    const property = useSelector(state => state.property);
    const booking = useSelector(state => state.booking);
    const propertyType = useSelector(state => state.propertyType);
    const region = useSelector(state => state.region);
    const currency = useSelector(state => state.currency);
    const dispatch = useDispatch();
    let navigate = useNavigate();

    // Create action creators bound to dispatch
    const userActions = {
        getUsers: (users) => dispatch(ActionUser.getUsers(users)),
        getUser: (user) => dispatch(ActionUser.getUser(user)),
        setFirstName: (name) => dispatch(ActionUser.setFirstName(name)),
        setEmail: (email) => dispatch(ActionUser.setEmail(email)),
        setPhone: (phone) => dispatch(ActionUser.setPhone(phone)),
        setTelegramSubscribeLink: (link) => dispatch(ActionUser.setTelegramSubscribeLink(link)),
        setStatusEmail: (status) => dispatch(ActionUser.setStatusEmail(status)),
        setStatusTelegram: (status) => dispatch(ActionUser.setStatusTelegram(status)),
        setTelegram: (telegram) => dispatch(ActionUser.setTelegram(telegram)),
        setStatusSms: (status) => dispatch(ActionUser.setStatusSms(status)),
        getChat: (chat) => dispatch(ActionUser.getChat(chat)),
        getChats: (chats) => dispatch(ActionUser.getChats(chats)),
        setId: (id) => dispatch(ActionUser.setId(id)),
        setPermissions: (permissions) => dispatch(ActionUser.setPermissions(permissions)),
        getUserProfile: (profile) => dispatch(ActionUser.getUserProfile(profile)),
        setUserProfileFirstName: (name) => dispatch(ActionUser.setUserProfileFirstName(name)),
        setUserProfileLastName: (name) => dispatch(ActionUser.setUserProfileLastName(name)),
        setUserProfileGender: (gender) => dispatch(ActionUser.setUserProfileGender(gender)),
        setUserProfileBirthdate: (birthdate) => dispatch(ActionUser.setUserProfileBirthdate(birthdate)),
        setUserProfilePhoto: (photo) => dispatch(ActionUser.setUserProfilePhoto(photo)),
        setUserProfileLocation: (location) => dispatch(ActionUser.setUserProfileLocation(location)),
        getUserPhones: (phones) => dispatch(ActionUser.getUserPhones(phones))
    };

    const internalSystemActions = {
        setIsEmptyPhone: (value) => dispatch(ActionInternalSystem.setIsEmptyPhone(value)),
        setIsRecoveryPassword: (value) => dispatch(ActionInternalSystem.setIsRecoveryPassword(value)),
        setIsResetPassword: (value) => dispatch(ActionInternalSystem.setIsResetPassword(value)),
        setIsMailMessageWasSent: (value) => dispatch(ActionInternalSystem.setIsMailMessageWasSent(value)),
        setIsAccessToRedirect: (value) => dispatch(ActionInternalSystem.setIsAccessToRedirect(value)),
        setIsCityWithMap: (value) => dispatch(ActionInternalSystem.setIsCityWithMap(value)),
        setPropertyWasCreated: (value) => dispatch(ActionInternalSystem.setPropertyWasCreated(value))
    };

    const reviewActions = {
        getReviews: (reviews) => dispatch(ActionReview.getReviews(reviews)),
        getReview: (review) => dispatch(ActionReview.getReview(review)),
        setScore: (score) => dispatch(ActionReview.setScore(score)),
        setBookingId: (id) => dispatch(ActionReview.setBookingId(id)),
        setPublicComment: (comment) => dispatch(ActionReview.setPublicComment(comment)),
        setPrivateComment: (comment) => dispatch(ActionReview.setPrivateComment(comment)),
        setIsAnonymous: (value) => dispatch(ActionReview.setIsAnonymous(value)),
        setIsReadManager: (value) => dispatch(ActionReview.setIsReadManager(value)),
        setIsReadHost: (value) => dispatch(ActionReview.setIsReadHost(value)),
        setExpandedReviewScores: (scores) => dispatch(ActionReview.setExpandedReviewScores(scores)),
        setPropertyId: (id) => dispatch(ActionReview.setPropertyId(id)),
        setStatus: (status) => dispatch(ActionReview.setStatus(status))
    };

    const propertyActions = {
        getProperties: (properties) => dispatch(ActionProperty.getProperties(properties)),
        getProperty: (property) => dispatch(ActionProperty.getProperty(property)),
        setCalendarDate: (date) => dispatch(ActionProperty.setCalendarDate(date)),
        setCoords: (coords) => dispatch(ActionProperty.setCoords(coords)),
        setPhotos: (photos) => dispatch(ActionProperty.setPhotos(photos)),
        getInitialPhotos: (photos) => dispatch(ActionProperty.getInitialPhotos(photos)),
        deletePhotos: () => dispatch(ActionProperty.deletePhotos()),
        setCurrency: (currency) => dispatch(ActionProperty.setCurrency(currency)),
        setCountryCode: (countryCode) => dispatch(ActionProperty.setCountryCode(countryCode)),
        setPhone: (phone) => dispatch(ActionProperty.setPhone(phone)),
        setRegion: (region) => dispatch(ActionProperty.setRegion(region)),
        setUnstructuredAddress: (address) => dispatch(ActionProperty.setUnstructuredAddress(address)),
        setAdType: (type) => dispatch(ActionProperty.setAdType(type)),
        setName: (name) => dispatch(ActionProperty.setName(name)),
        setDescription: (description) => dispatch(ActionProperty.setDescription(description)),
        setCostPerPeriod: (cost) => dispatch(ActionProperty.setCostPerPeriod(cost)),
        setPrice: (price) => dispatch(ActionProperty.setPrice(price)),
        setGuests: (guests) => dispatch(ActionProperty.setGuests(guests)),
        setInstantBookingAvailable: (value) => dispatch(ActionProperty.setInstantBookingAvailable(value)),
        setBedroomsInfo: (info) => dispatch(ActionProperty.setBedroomsInfo(info)),
        setSummaryNumberOfBedrooms: (count) => dispatch(ActionProperty.setSummaryNumberOfBedrooms(count)),
        setSummaryNumberOfBeds: (count) => dispatch(ActionProperty.setSummaryNumberOfBeds(count)),
        setSummaryNumberOfBathrooms: (count) => dispatch(ActionProperty.setSummaryNumberOfBathrooms(count)),
        getClosedBookingDates: (dates) => dispatch(ActionProperty.getClosedBookingDates(dates)),
        setAddress: (address) => dispatch(ActionProperty.setAddress(address)),
        setAddressSuplement: (supplement) => dispatch(ActionProperty.setAddressSuplement(supplement)),
        setStatus: (status) => dispatch(ActionProperty.setStatus(status)),
        setAdditionalGuests: (guests) => dispatch(ActionProperty.setAdditionalGuests(guests)),
        setCostPerAdditionalGuest: (cost) => dispatch(ActionProperty.setCostPerAdditionalGuest(cost)),
        setPetFee: (fee) => dispatch(ActionProperty.setPetFee(fee)),
        setAdditionalPrice: (price) => dispatch(ActionProperty.setAdditionalPrice(price)),
        setAmenities: (amenities) => dispatch(ActionProperty.setAmenities(amenities)),
        getIcals: (icals) => dispatch(ActionProperty.getIcals(icals)),
        getIcal: (ical) => dispatch(ActionProperty.getIcal(ical)),
        getPropertiesForMap: (properties) => dispatch(ActionProperty.getPropertiesForMap(properties)),
        getRules: (rules) => dispatch(ActionProperty.getRules(rules)),
        setRulesCheckInTime: (time) => dispatch(ActionProperty.setRulesCheckInTime(time)),
        setRulesCheckOutTime: (time) => dispatch(ActionProperty.setRulesCheckOutTime(time)),
        setRulesMinStayDays: (days) => dispatch(ActionProperty.setRulesMinStayDays(days)),
        setRulesSuitableForChildren: (value) => dispatch(ActionProperty.setRulesSuitableForChildren(value)),
        setRulesSuitableForInfants: (value) => dispatch(ActionProperty.setRulesSuitableForInfants(value)),
        setRulesPetsAllowed: (value) => dispatch(ActionProperty.setRulesPetsAllowed(value)),
        setRulesSmokingAllowed: (value) => dispatch(ActionProperty.setRulesSmokingAllowed(value)),
        setRulesEventsAllowed: (value) => dispatch(ActionProperty.setRulesEventsAllowed(value)),
        setRulesWithRentalAgreement: (value) => dispatch(ActionProperty.setRulesWithRentalAgreement(value)),
        setRulesDamageDepositAmount: (amount) => dispatch(ActionProperty.setRulesDamageDepositAmount(amount)),
        setRulesDamageDepositCurrency: (currency) => dispatch(ActionProperty.setRulesDamageDepositCurrency(currency)),
        setRulesDownPaymentAmount: (amount) => dispatch(ActionProperty.setRulesDownPaymentAmount(amount)),
        setRulesAdditionalRules: (rules) => dispatch(ActionProperty.setRulesAdditionalRules(rules))
    };

    const bookingActions = {
        getBookings: (bookings) => dispatch(ActionBooking.getBookings(bookings)),
        getBooking: (booking) => dispatch(ActionBooking.getBooking(booking)),
        getAddedBooking: (booking) => dispatch(ActionBooking.getAddedBooking(booking))
    };

    const propertyTypeActions = {
        getPropertyType: (type) => dispatch(ActionPropertyType.getPropertyType(type)),
        getPropertyTypes: (types) => dispatch(ActionPropertyType.getPropertyTypes(types)),
        setName: (name) => dispatch(ActionPropertyType.setName(name))
    };

    const regionActions = {
        getRegion: (region) => dispatch(ActionRegion.getRegion(region)),
        getRegions: (regions) => dispatch(ActionRegion.getRegions(regions)),
        setName: (name) => dispatch(ActionRegion.setName(name)),
        setParentId: (id) => dispatch(ActionRegion.setParentId(id)),
        setLat: (lat) => dispatch(ActionRegion.setLat(lat)),
        setLng: (lng) => dispatch(ActionRegion.setLng(lng))
    };

    const currencyActions = {
        getCurrencies: (currencies) => dispatch(ActionCurrency.getCurrencies(currencies)),
        getCurrency: (currency) => dispatch(ActionCurrency.getCurrency(currency)),
        setIsoCode: (code) => dispatch(ActionCurrency.setIsoCode(code))
    };

    useEffect(() => {
        const redirectToLogin = redirectToLoginWithReturn;

        if (Cookies.get('token')) {
            getUser({ ...props, userActions })
                .then((res) =>
                    {
                        if (res.payload?.message === 'Unauthenticated.') {
                            redirectToLogin();
                        } else {
                            setIsLoaded(true)
                        }
                    },
                    (error) => console.log(error)
                )
        } else {
            redirectToLogin();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <ThemeProvider theme={themeContent}>
            <div className="container" style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <header style={{ flex: '0 0 auto' }}>
                    <Menu {...props} user={user} />
                    <NavigationTabs {...props} />
                </header>
                <main style={{ flex: '1 0 auto' }}>
                    <CssBaseline />
                    <Container maxWidth="false">
                        <ErrorBoundary>
                            <Suspense fallback={<SimpleLoader />}>
                                {isLoaded && <Outlet context={{ ...props, user, userActions, internalSystem, internalSystemActions, review, reviewActions, property, propertyActions, booking, bookingActions, propertyType, propertyTypeActions, region, regionActions, currency, currencyActions }} />}
                            </Suspense>
                        </ErrorBoundary>
                    </Container>
                </main>
                <footer style={{ flex: '0 0 auto' }}>
                    <Footer {...props} user={user} />
                </footer>
            </div>
        </ThemeProvider>
    );
}
